import { h, Fragment } from "preact";

import { Stack, } from "@mui/material";
import CardTemplate from "../Common/CardTemplate";
import ButtonWithTooltipAndBadge from "../Common/ButtonWithTooltipAndBadge";
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import GroupAddIcon from '@mui/icons-material/GroupAdd';

import SellerCard from "../Common/SellerCard";

export default function SellersCard({ actualDeal, mode, btn }) {

    return (
        <CardTemplate
            title="Vendeurs"
            buttons={
                btn
            }

            content={
                <Stack spacing={1}>
                    {actualDeal.sellers.map((row) => {
                        return <SellerCard row={row} mode={mode} />;
                    })}
                    {actualDeal.sellers.length === 0 &&
                        <em>Pas de vendeur enregistré</em>
                    }
                </Stack>
            }
        />)

}